export default "__VITE_ASSET__BAz432tl__"